module.exports = __webpack_public_path__ + "img/p3_3.62da4e00.png";